<template>
    <v-dialog
        v-model="$store.state.newTransact.exceptionRev"
        persistent
        min-width="1360px"
        transition="dialog-transition"
    >
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">
                    Exceptions
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    color="white"
                    dark
                    icon
                    @click="$store.state.newTransact.exceptionRev = false"
                    ><v-icon>mdi-close-circle</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <!-- <v-data-table :headers="headersExeptions" :items="exeptions"  dense :search="search"
                    class="elevation-1"  pagination.sync="pagination">
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model="search" label="Search" class="mb-1" dense
                                    style="margin-top: 0px;padding: 10px;" hide-details></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-btn color="primary" small class="my-auto ml-2" @click="downloadExcelExceptions">Export
                                    <v-icon>mdi-microsoft-excel</v-icon></v-btn>
                            </v-col>
                            <v-col cols="1">

                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn color="primary" x-small @click="GotoTransact(item)">Transacting</v-btn>
                    </template>
                </v-data-table> -->
                <v-col cols="12">
                    <v-data-table
                        :headers="transHeaders"
                        :items="transactions"
                        :search="search"
                        dense
                        class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar color="primary" dense dark>
                                <v-spacer></v-spacer>
                                <v-toolbar-title class="white--text">
                                    MOQ & Splits
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        v-model="search"
                                        label="Search"
                                        class="mb-1"
                                        dense
                                        style="margin-top: 0px;padding: 10px;"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn
                                        color="primary"
                                        small
                                        class="mt-4 ml-2"
                                        @click="downloadExcelExceptions"
                                        >Export
                                        <v-icon
                                            >mdi-microsoft-excel</v-icon
                                        ></v-btn
                                    >
                                </v-col>
                                <v-col cols="1"> </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn
                                color="primary"
                                x-small
                                @click="GotoTransact(item)"
                                >Transacting</v-btn
                            >
                        </template>
                    </v-data-table>
                </v-col>
            </v-container>
        </v-card>

        <transacting
            v-if="$store.state.newTransact.transacting"
            :searchShift="shift"
        ></transacting>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import transacting from './../TransactingModal.vue';
export default {
    props: ['exeptions', 'Shifts', 'customer'],
    components: {
        transacting
    },
    data: function() {
        return {
            search: '',
            transHeaders: [
                { text: 'ShiftDetail', value: 'ShiftDetail' },
                { text: 'BOL', value: 'BillOfLading' },
                { text: 'Order', value: 'OrderNumber' },
                { text: 'L1', value: 'LoadNum' },
                { text: 'L2', value: 'LoadNumOrd' },
                { text: 'DateTerminalPick', value: 'DateTerminalPick' },
                { text: 'Shift', value: 'Shift', width: '10%' },
                { text: 'Terminal', value: 'TerminalName' },
                { text: 'Station', value: 'Station' },
                { text: 'City', value: 'City' },
                { text: 'Split Type', value: 'SplitTypeName' },
                { text: 'NoLoad Type', value: 'NoLoadTypeName' },
                { text: 'Order Type', value: 'OrderType' },

                //
                {
                    text: 'Transaction Type',
                    value: 'TranTypeName',
                    width: '20%'
                },
                // { text: 'Product', value: 'Product', width: '10%' },
                { text: 'Qty', value: 'Quantity' },
                { text: 'Rate', value: 'Rate' },
                { text: 'Amount', value: 'Amount' },
                { text: 'Go', value: 'action' }
            ],
            transactions: [],
            headersExeptions: [
                { text: 'Customer', value: 'Customer' },
                { text: 'Terminal PickUp', value: 'DateTerminalPick' },
                { text: 'ShiftDetail', value: 'ShiftDetail' },
                { text: 'NumAxles', value: 'NumAxles' },
                { text: 'Order', value: 'OrderID' },
                { text: 'NoAllocation', value: 'NoAllocation' },
                { text: 'SplitTypeName', value: 'SplitTypeName' },
                { text: 'NoLoadTypeName', value: 'NoLoadTypeName' },
                { text: 'Type', value: 'Type' },
                { text: 'Qty Order', value: 'nqtyOrder' },
                { text: 'Qty Total', value: 'nqtyTotal' },
                { text: 'Dip Qty', value: 'DispatchedQuantity' },
                { text: 'Go', value: 'action' }
            ]
        };
    },

    mounted() {
        console.log(this.customer);
        this.ShowTransacted();
    },
    methods: {
        GotoTransact: function(item) {
            this.$store.state.newTransact.transacting = true;
            this.shift = item.ShiftDetail;
        },
        downloadExcelExceptions: function() {
            var str = this.$store;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Customer: null,
                Export: 1,
                Exception: 1
            };
            if (this.customer != null) {
                parms.Customer = this.customer.id;
            }
            str.state.isLoading = true;
            axios
                .post('new-transaction/transacted', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Exception Revenue.xlsx');
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        ShowTransacted: function() {
            var str = this.$store;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Customer: null,
                Export: 0,
                Exception: 1
            };
            if (this.customer != null) {
                parms.Customer = this.customer.id;
            }
            console.log(parms);
            str.state.isLoading = true;
            axios
                .post('new-transaction/transacted', parms)
                .then(async response => {
                    this.transactions = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
